import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { IDashboardParams, IResponseDashboardCentral } from "../../interface";
import { axiosCentral, throwResponse } from "config/axios";
import { IMdpc } from "./interface";

export const useGetDashboardMDPC = (
  params?: IDashboardParams
): UseQueryResult<IResponseDashboardCentral<IMdpc>[], Error> => {
  return useQuery(
    ["dashboard-mdpc", "count-by-types", params],
    async () => {
      const res = await axiosCentral.get("dashboard/mdpc/count-by-types", {
        params,
      });
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    {
      enabled: params?.enabled,
    }
  );
};
